import React from 'react';
import { Link } from 'react-router-dom';

export default function FooterNav() {
	const links = [
		{ title: 'Home', link: '/' },
		{ title: 'About Us', link: '/about-us' },
		// { title: 'Project Gallery', link: '/project-gallery' },
		{ title: 'Gallery', link: '/gallery' },
		{ title: 'Privacy Policy', link: '/privicy-policy' },
	];


	return (

		
		<>
			<div className="footer-heading">
				<h6 className="text-white">Quick Links</h6>
			</div>
			<ul className="list-unstyled footer-nav mb-0 d-flex flex-column">
				{links.map((item, index) => (
					<li className="position-relative" key={index}>
						<Link to={item.link} className="text-decoration-none">
							{item.title}
						</Link>
					</li>
					// <Link to="/privicy-policy">Privacy Policy</Link>
				))}
			</ul>
		</>
	);
}

